import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import "jspdf-autotable";
import jsPDF from "jspdf";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  configure,
  ZipWriter,
  BlobWriter,
  BlobReader,
  TextReader,
} from "@zip.js/zip.js";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
  Box,
  useMediaQuery,
  Select,
  MenuItem,
  Skeleton,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  IconButton,
  Avatar,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { Add, Edit, ExpandMore } from "@mui/icons-material";

import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FeedIcon from "@mui/icons-material/Feed";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GetAppIcon from "@mui/icons-material/GetApp";

import CommonButton from "../../Components/InputComponents/CommonButton";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { decryptId, encryptId } from "../../Components/CryptoComponent";
import ProcessFlowViewer from "./ProcessFlowViewer";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";

import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import TextInput from "../../Components/InputComponents/TextInput";

const CandidateProfile = () => {
  const getIcon = (status, color) => {
    switch (status) {
      case "Completed":
        return <CheckCircleIcon sx={{ color, fontSize: 24 }} />;
      case "In Progress":
        return <AccessTimeIcon sx={{ color, fontSize: 24 }} />;
      case "Draft":
        return <FeedIcon sx={{ color, fontSize: 24 }} />;

      default:
        return null;
    }
  };

  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));
  const [decryptedJAId, setdecryptedJAId] = useState(null);

  // onclicking a particular job from applied job list..

  const location = useLocation();
  const navigate = useNavigate();

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const applicantdecryptedId = location?.state?.decryptedId;

  const filterData = location?.state?.filterData;

  const expandedIds = location?.state?.expandedIds || "";
  const open = location?.state?.open || "";

  const isMobile = useMediaQuery("(max-width: 1220px)");

  const [selectedProfileTab, setSelectedProfileTab] = useState(0);

  const [candidateID, setCandidateID] = useState("");

  const [personalDetails, setPersonalDetails] = useState({
    Name: "",
    Alias_Name: "",
    Date_Of_Birth: "",
    Passport_Number: "",
    Mobile: "",
    Emergency_Mobile: "",
    Primary_Email: "",
    Secondary_Email: "",
    Address: "",
    CI_Photo: "",
  });

  const [jobDetails, setJobDetails] = useState({
    Job_Title: "",
    Designation: "",
    Is_Medical: "",
    Years_Of_Experience: "",
    Gap_In_Experience: "",
    Gap_Details: "",
    Working_Status: "",
    Department_1: "",
    Department_2: "",
    Department_3: "",
    Designation: "",
    License_Info: "",
    License_Expiry: "",
    Employer: "",
    Contract_Type: "",
    Work_Location: "",
    Accommodation_Provided: "",
    Transportation_Provided: "",
    Basic_Salary: "",
    Other_Benefits: "",
  });

  const [appliedJobs, setAppliedJobs] = useState([]);

  const [statusList, setStatusList] = useState([]);

  const [countryID, setCountryID] = useState(null);
  const [professionID, setProfessionID] = useState(null);
  const [recruitmentProfession, setRP] = useState(null);
  const [recruitmentCountry, setRC] = useState(null);

  const [selectedJobListId, setSelectedJobListId] = useState("");

  const [selectedJobName, setSelectedJobName] = useState("");

  const [selectedJobID, setSelectedJobID] = useState("");

  const [mainValue, setMainValue] = useState(0);

  const handleChange = (event) => {
    const selected = appliedJobs.find((job) => job.JD_JobId === event);
    setSelectedJobListId(event);

    if (selected) {
      setCountryID(selected.JD_Country);
      setProfessionID(selected.JD_Profession);
      setRP(selected.Recruitment_Profession);
      setRC(selected.Recruitment_Country);
      setDeployed(selected.JA_Isdeployed);
      setCancelled(selected?.JD_Cancelled);
      setCancelRemarkPreview(selected?.JD_CancelRemarks);
      setdecryptedJAId(selected?.JobApplicationId);
      setSelectedJobName(selected?.JD_Title);
      setSelectedJobID(selected?.JD_JobId);
    }
  };

  const [callInterview, setCallInterview] = useState(false);

  const handleStatusChange = (job, e) => {
    axiosAPI
      ?.post(`/Candidate/updateInterviewStatus/${job?.JobApplicationId}`, {
        JA_CandidateId: candidateID,
        JA_JobId: job?.JobId,
        JA_StatusId: e?.target.value,
      })
      .then((res) => {
        if (res?.data?.success) {
          successNotify(res?.data?.data?.message);
          getData2();
        } else {
          errorNotify(res?.data?.data?.message);
        }
      })
      .catch((err) => {});
  };

  // decryptedId & decryptedJAId
  const getData = async () => {
    await axiosAPI
      .get(`/Candidate/listbyIdForView/${decryptedId}`)
      .then((res) => {
        const dataFromApi = res.data.data;

        setCandidateID(dataFromApi?.CI_Id);
        setAppliedJobs(dataFromApi?.jobs);

        if (dataFromApi?.jobs?.length) {
          const selectedJobIndex = location?.state?.selectedJobIndex;

          // find job by ID if provided
          const matchedJob = dataFromApi.jobs.find(
            (job) => job.JD_JobId === selectedJobIndex
          );

          // pick matched job or fallback to first job
          const finalJob = matchedJob || dataFromApi.jobs[0];

          // set IDs and call handler
          setSelectedJobListId(finalJob.JD_JobId);
          setSelectedProfileTab(
            matchedJob ? location?.state?.selectedProfileTab : 0
          );

          handleChange(finalJob.JD_JobId);

          // update related states based on finalJob

          setCountryID(finalJob?.JD_Country);
          setProfessionID(finalJob?.JD_Profession);
          setRP(finalJob?.Recruitment_Profession);
          setRC(finalJob?.Recruitment_Country);
          setDeployed(finalJob?.JA_Isdeployed);
          setCancelled(finalJob?.JD_Cancelled);
          setCancelRemarkPreview(finalJob?.JD_CancelRemarks);
          setdecryptedJAId(
            location?.state?.decryptedJAId
              ? location?.state?.decryptedJAId
              : finalJob?.JobApplicationId
          );
          setSelectedJobName(
            location?.state?.selectedJobName
              ? location?.state?.selectedJobName
              : finalJob?.JD_Title
          );
          // setSelectedStatus(finalJob?.JASL_Id);
        }

        setPortalAccess(dataFromApi?.CI_PortalAccess);

        setPersonalDetails({
          Name: dataFromApi?.CI_Name || "-",
          Alias_Name: dataFromApi?.CI_Alias || "-",
          Age: dataFromApi?.CI_Age > 0 ? dataFromApi?.CI_Age : "-" || "-",
          Date_Of_Birth:
            dataFromApi?.CI_Dateofbirth &&
            dataFromApi?.CI_Dateofbirth !== "00-00-0000"
              ? dataFromApi.CI_Dateofbirth
              : "-",
          Passport_Number: dataFromApi?.CI_PassportNo || "-",
          Mobile: dataFromApi?.CI_PrimaryMobile || "-",
          Emergency_Mobile: dataFromApi?.CI_EmergencyMobile || "-",
          Primary_Email: dataFromApi?.CI_PrimaryEmail || "-",
          Secondary_Email: dataFromApi?.CI_SecondaryEmail || "-",
          Address: dataFromApi?.CI_Address || "-",
          CI_Photo: dataFromApi?.CI_Photo,

          Updated_By: dataFromApi?.UpdatedBy || "-",
          Updated_On: dataFromApi?.UpdatedOn || "-",
        });

        setJobDetails({
          Job_Title: dataFromApi?.CI_Profession || "-",
          Designation: dataFromApi?.CI_Designation || "-",
          Is_Medical: dataFromApi?.CI_IsMedical == 1 ? "Yes" : "No",
          Years_Of_Experience: dataFromApi?.CI_YearofExp || "-",
          Gap_In_Experience: dataFromApi?.CI_CareerGap?.toString() || "-",
          Gap_Details: dataFromApi?.CI_CareerGapDetl || "-",
          Working_Status:
            dataFromApi?.CI_Last_working_date &&
            dataFromApi?.CI_Last_working_date != "00-00-0000"
              ? `Last Worked: ${dataFromApi?.CI_Last_working_date}`
              : "Working",
          Department_1: dataFromApi?.CI_Department1 || "-",
          Department_2: dataFromApi?.CI_Department2 || "-",
          Department_3: dataFromApi?.CI_Department3 || "-",
          Designation: dataFromApi?.CI_Designation || "-",
          License_Info: dataFromApi?.CI_Registration_License || "-",
          License_Expiry: dataFromApi?.CI_Registration_License_expry || "-",
          // 'Employer': "",
          // "Contract Type": "",
          // "Work Location": "",
          // "Accommodation Provided": "",
          // "Transportation Provided": "",
          // "Basic Salary": "",
          // "Other Benefits": "",
        });
      })
      .catch((err) => {});
  };

  const getData2 = async () => {
    await axiosAPI
      .get(`/Candidate/listbyIdForView/${decryptedId}`)
      .then((res) => {
        const dataFromApi = res.data.data;

        setCandidateID(dataFromApi?.CI_Id);
        setAppliedJobs(dataFromApi?.jobs);
      })
      .catch((err) => {});
  };

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // mainAPICallback -> decryptedId & decryptedJAId
  const fetchProcessStatus = () => {
    axiosAPI
      .get(`/RecruitmentProcedure/recruitment/${decryptedId}/${decryptedJAId}`)
      .then((res) => {
        const { CandidateField, RPM_Id } = res?.data?.data || {};
        setrpmID(RPM_Id);

        if (CandidateField) {
          setOriginalValue2(CandidateField);
        }
      })
      .catch((error) => {
        console.error("Error fetching process status:", error);
      });
  };

  // decryptedId & decryptedJAId
  const fetchProcessData = () => {
    setLoading(true);

    axiosAPI
      .get(`/RecruitmentProcedure/recruitment/${decryptedId}/${decryptedJAId}`)
      .then((res) => {
        setMainValue(0);
        const { CandidateField, RPM_Id } = res?.data?.data || {};

        setrpmID(RPM_Id);

        if (CandidateField) {
          setOriginalValue(CandidateField);
          const dataWithInitializedValues = JSON.parse(
            JSON.stringify(CandidateField)
          );

          dataWithInitializedValues.stages.forEach((stage) => {
            if (stage.fields) {
              stage.fields.forEach((field) => {
                if (!field.hasOwnProperty("RPF_Value")) {
                  if (field.RPF_Type === "Checkbox") {
                    field.RPF_Value = false;
                  } else if (field.RPF_Type === "Number") {
                    field.RPF_Value = null;
                  } else {
                    field.RPF_Value = "";
                  }
                }
              });
            }

            if (stage.subProcedures) {
              stage.subProcedures.forEach((sub) => {
                sub.fields.forEach((field) => {
                  if (!field.hasOwnProperty("RPF_Value")) {
                    if (field.RPF_Type === "Checkbox") {
                      field.RPF_Value = false;
                    } else if (field.RPF_Type === "Number") {
                      field.RPF_Value = null;
                    } else {
                      field.RPF_Value = "";
                    }
                  }
                });
              });
            }
          });

          setCurrentProcessFlowData(dataWithInitializedValues);
        } else {
          setErrorParent("No process flow is associated with this candidate.");
        }
      })
      .catch((error) => {
        console.error("Error fetching process data:", error);
        setErrorParent("An error occurred while fetching process data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [loading, setLoading] = useState(true);
  const [errorParent, setErrorParent] = useState(null);

  const [rpmID, setrpmID] = useState(null);

  const [originalValue, setOriginalValue] = useState([]);
  const [originalValue2, setOriginalValue2] = useState([]);
  const [currentProcessFlowData, setCurrentProcessFlowData] = useState(null);

  const [mainAPICallback, setMainAPICallback] = useState(false);

  const [portalAccess, setPortalAccess] = useState(0);
  const [deployed, setDeployed] = useState(0);
  const [cancelled, setCancelled] = useState(0); // implement as needed

  const [confirmOpen, setConfirmOpen] = useState(false);

  const [pendingChange, setPendingChange] = useState(null);

  const [cancelRemark, setCancelRemark] = useState("");

  const [cancelRemarkPreview, setCancelRemarkPreview] = useState("");

  const handleCheckboxClick = (type, value) => {
    setPendingChange({ type, value });
    setConfirmOpen(true);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
    setCancelRemark(""); // clear on close
    setPendingChange(""); // optional
  };

  const handleCheckboxConfirm = async () => {
    if (!pendingChange) return;

    const { type, value } = pendingChange;

    if (type === "Web Portal Access") {
      axiosAPI
        .post("/Candidate/updateportalaccess", {
          CandidateID: decryptedId,
          IsAccess: value ? 1 : 0,
        })
        .then((res) => {
          if (res?.data?.success) {
            successNotify(res?.data?.data?.message);
            setPortalAccess(value ? 1 : 0);
            setConfirmOpen(false);
            setPendingChange(null);
          } else {
          }
        })
        .catch((err) => {});
    }

    if (type === "Deployed") {
      const currentDate = new Date().toISOString().split("T")[0];
      axiosAPI
        .post("/Candidate/updatedeploymentstatus", {
          JA_Isdeployed: value ? 1 : 0,
          JA_deployedDate: currentDate,
          JA_Id: decryptedJAId,
          JA_CandidateId: decryptedId,
        })
        .then((res) => {
          if (res?.data?.success) {
            successNotify(res?.data?.message);
            setConfirmOpen(false);
            setPendingChange(null);
            setDeployed(value ? 1 : 0);
            getData2();
          } else {
            infoNotify(res?.data?.message);
          }
        })
        .catch((err) => {});
    }

    if (type === "Cancelled") {
      const currentDate = new Date().toISOString().split("T")[0];
      axiosAPI
        .post("/Candidate/updatecancelstatus", {
          JA_IsCancelled: value ? 1 : 0,
          JA_deployedDate: currentDate,
          JA_CancelRemarks: cancelRemark,
          JA_Id: decryptedJAId,
          JA_CandidateId: decryptedId,
        })
        .then((res) => {
          if (res?.data?.success) {
            successNotify(res?.data?.message);
            setCancelRemark("");
            setCancelRemarkPreview(cancelRemark);
            setConfirmOpen(false);
            setPendingChange(null);
            setCancelled(value ? 1 : 0);
            getData2();
          } else {
            infoNotify(res?.data?.message);
          }
        })
        .catch((err) => {
          setCancelled(0);
        });
    }
  };

  useEffect(() => {
    if (decryptedId && decryptedJAId) {
      fetchProcessData();
    }
  }, [decryptedId, decryptedJAId]);

  useEffect(() => {
    if (decryptedId && decryptedJAId) {
      fetchProcessStatus();
    }
  }, [mainAPICallback, decryptedJAId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
    getStatus();
  }, [location?.state?.decryptedJAId]);

  // useEffect(() => {
  //   if (location?.state?.selectedJobIndex) {
  //     handleChange(location?.state?.selectedJobIndex);
  //     setSelectedJobListId(location?.state?.selectedJobIndex);
  //   }
  // }, [location?.state?.selectedJobIndex]);

  const stateToSend = {
    decryptedId: decryptedId,
    Tab: 2,
    selectedJobID: selectedJobListId,
    decryptedJAId: decryptedJAId,
    selectedJobName: selectedJobName,
    selectedJobIndex: selectedJobListId,
    selectedProfileTab: selectedProfileTab,
  };

  const navigatetoJobLinkingAdd = () => {
    const encrypted = encodeURIComponent(encryptId(decryptedId));
    navigate(`/JobLinking/Add/${encrypted}`, { state: stateToSend });
  };

  const navigatetoJobLinkingEdit = (id) => {
    const encrypted = encodeURIComponent(encryptId(id?.JobApplicationId));
    navigate(`/JobLinking/Edit/${encrypted}`, { state: stateToSend });
  };

  const [expanded, setExpanded] = useState(true); // Accordion state

  const handleAccordionToggle = () => {
    setExpanded((prev) => !prev);
  };

  const redGridRef = useRef(null);
  const [redGridHeight, setRedGridHeight] = useState(0);

  useLayoutEffect(() => {
    if (selectedProfileTab == 2) {
      setTimeout(() => {
        if (redGridRef.current) {
          if (expanded) {
            setRedGridHeight(redGridRef.current.offsetHeight);
          }
        }
      }, 1000);
    } else {
      if (redGridRef.current) {
        setRedGridHeight(redGridRef.current.offsetHeight);
      }
    }
  }, [selectedProfileTab, personalDetails, jobDetails, appliedJobs]);

  useEffect(() => {
    // if (location?.state?.selectedProfileTab) {
    //   setSelectedProfileTab(location?.state?.selectedProfileTab);
    // }

    if (location?.state?.decryptedJAId != null) {
      setdecryptedJAId(location?.state?.decryptedJAId);
    }

    if (location?.state?.selectedJobName != null) {
      setSelectedJobName(location?.state?.selectedJobName);
    }
  }, [location?.state]);

  // -------------------------------------------------------------------------------------------------------------

  configure({ useWebWorkers: false });

  const defaultZipName = personalDetails?.Name
    ? `${personalDetails.Name.trim()} Details.zip`
    : "Candidate Details.zip";

  const [zipFileName, setZipFileName] = useState(defaultZipName);

  const [openExport, setOpenExport] = useState(false);
  const [zipPassword, setZipPassword] = useState("");
  const [error, setError] = useState("");

  const handleOpenModal = () => {
    const fallback = "Candidate Details.zip";
    const name = personalDetails?.Name?.trim();
    setZipFileName(name ? `${name} Details.zip` : fallback);
    setOpenExport(true);
  };

  const generatePDF = async (title, data) => {
    const doc = new jsPDF();
    doc.setFont("Geist, sans-serif", "bold");
    doc.text(title, 14, 20);
    doc.setFont("Geist, sans-serif", "normal");

    // Draw image (avatar) if CI_Photo exists and is valid
    const imageUrl = data.CI_Photo;

    if (imageUrl) {
      try {
        const image = await loadImageAsBase64(imageUrl);
        const imgSize = 30;
        const imgX = 160;
        const imgY = 10;
        doc.addImage(
          image,
          "JPEG",
          imgX,
          imgY,
          imgSize,
          imgSize,
          undefined,
          "FAST"
        );
      } catch (error) {
        console.warn("Failed to load CI_Photo:", error);
      }
    }

    // Convert entries, skipping CI_Photo
    const rows = Object.entries(data)
      .filter(([key]) => key !== "CI_Photo")
      .map(([key, value]) => [formatLabel(key), value || "-"]);

    doc.autoTable({
      startY: 50, // leave space for avatar
      head: [["Field", "Value"]],
      body: rows,
      styles: { fontSize: 10 },
      // theme: "grid",
      columnStyles: {
        0: { cellWidth: 60 }, // Field column (approx. 33% of A4 width)
        1: { cellWidth: 120 }, // Value column (approx. 66%)
      },
      headStyles: {
        fillColor: [42, 110, 185], // #2A6EB9
        textColor: 255, // white text
        fontStyle: "bold",
        halign: "left",
      },
    });

    return doc.output("blob"); // Promise<Blob>
  };

  // Format "Years_Of_Experience" => "Years Of Experience"
  const formatLabel = (label) =>
    label
      .replace(/_/g, " ")
      .replace(
        /\w\S*/g,
        (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
      );

  // Load image from URL or base64 and convert to base64 DataURL
  const loadImageAsBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.onerror = reject;
      img.src = `${process.env.REACT_APP_BASE_URL}/${url}`;
    });
  };

  const handleExport = async () => {
    try {
      const doc = new jsPDF();
      const candidateName = personalDetails?.Name?.trim() || "Candidate";
      const pdfTitle = `Candidate Details - ${candidateName}`;
      const pdfFilename = `${pdfTitle}.pdf`;

      // Title
      doc.setFont("Geist, sans-serif", "bold");
      doc.text(pdfTitle, 14, 20);
      doc.setFont("Geist, sans-serif", "normal");

      // Avatar (CI_Photo)
      const imageUrl = personalDetails.CI_Photo;
      if (imageUrl) {
        try {
          const image = await loadImageAsBase64(imageUrl);
          doc.addImage(image, "JPEG", 160, 10, 30, 30, undefined, "FAST");
        } catch (error) {
          console.warn("Failed to load CI_Photo:", error);
        }
      }

      // --- Personal Details Section ---
      doc.setFont("Geist, sans-serif", "bold");
      doc.text("Personal Details", 14, 40);
      doc.setFont("Geist, sans-serif", "normal");

      const personalRows = Object.entries(personalDetails)
        .filter(([key]) => key !== "CI_Photo")
        .map(([key, value]) => [formatLabel(key), value || "-"]);

      doc.autoTable({
        startY: 45,
        head: [["Field", "Value"]],
        body: personalRows,
        styles: { fontSize: 10 },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 120 },
        },
        headStyles: {
          fillColor: [42, 110, 185], // #2A6EB9
          textColor: 255,
          fontStyle: "bold",
          halign: "left",
        },
      });

      // --- Experience Details Section ---
      const afterPersonalY = doc.lastAutoTable.finalY + 10;
      doc.setFont("Geist, sans-serif", "bold");
      doc.text("Experience Details", 14, afterPersonalY);
      doc.setFont("Geist, sans-serif", "normal");

      const jobRows = Object.entries(jobDetails).map(([key, value]) => [
        formatLabel(key),
        value || "-",
      ]);

      doc.autoTable({
        startY: afterPersonalY + 5,
        head: [["Field", "Value"]],
        body: jobRows,
        styles: { fontSize: 10 },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 120 },
        },
        headStyles: {
          fillColor: [42, 110, 185],
          textColor: 255,
          fontStyle: "bold",
          halign: "left",
        },
      });

      const pdfBlob = await doc.output("blob");

      // Create password-protected zip
      const zipWriter = new ZipWriter(new BlobWriter("application/zip"), {
        password: zipPassword.trim() || null,
        encryptionStrength: 3,
      });

      await zipWriter.add(pdfFilename, new BlobReader(pdfBlob));
      const zipBlob = await zipWriter.close();

      // Download
      const url = URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;

      const zipName = zipFileName.trim() || `${candidateName} Details.zip`;
      a.download = zipName.endsWith(".zip") ? zipName : `${zipName}.zip`;
      a.click();
      URL.revokeObjectURL(url);

      // Cleanup
      setZipPassword("");
      setError("");
      setOpenExport(false);
    } catch (err) {
      console.error("ZIP creation failed:", err);
      setError("Failed to export. Please try again.");
    }
  };

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        {/* Left Side: Back Button + Heading */}
        <Grid item xs={12} md="auto">
          <Box display="flex" alignItems="center">
            <CommonButton
              variant="outlined"
              background="#006CB8"
              onClick={() => {
                navigate("/Candidates", {
                  state: {
                    pagination: paginationState,
                    filterData: filterData,
                    expandedIds: expandedIds,
                    open: open,
                    selectedJobIndex: selectedJobListId,
                    selectedProfileTab: selectedProfileTab,
                  },
                });
              }}
              margin="10px 20px 10px 0px"
            >
              <ArrowBackIcon sx={{ color: "white" }} />
            </CommonButton>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "24px",
                fontFamily: "Geist, sans-serif",
              }}
            >
              Candidate Profile
            </Typography>
          </Box>
        </Grid>

        {/* Right Side: Portal Access + Export */}
        <Grid
          item
          xs={12}
          md="auto"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            marginLeft: "auto",
            flexWrap: "wrap", // ensures responsiveness on smaller screens
          }}
        >
          <Box
            sx={{
              border: "1px solid #006CB8",
              borderRadius: 2,
              pl: 2,
              // py: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Geist, sans-serif",
                letterSpacing: "0.5px",
                fontSize: "14px",
                color: "#333",
                fontWeight: 600,
              }}
            >
              Web Portal Access
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={portalAccess === 1}
                  onChange={(e) =>
                    handleCheckboxClick("Web Portal Access", e.target.checked)
                  }
                  color="primary"
                />
              }
              label="" // no label since it's part of Typography
              sx={{ ml: 0.5 }}
            />
          </Box>

          <Button
            variant="contained"
            sx={{
              fontFamily: "Geist, sans-serif",
              bgcolor: "#009132",
              color: "white",
              textTransform: "capitalize",
              borderRadius: 2,
              whiteSpace: "nowrap",
              height: "100%", // aligns with box height
            }}
            onClick={handleOpenModal}
            endIcon={<GetAppIcon />}
          >
            Export
          </Button>
        </Grid>
      </Grid>

      <br />

      {/* Main Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column", // stack on mobile
            md: "row", // side-by-side on desktop
          },
          alignItems: "stretch",
          gap: 2,
          width: "100%",
        }}
      >
        {/* Left Side - Personal Details & Job Details */}
        <Box
          sx={{
            width: {
              xs: "100%", // full width on small screens
              sm: "100%", // side-by-side on larger screens
              md:
                !originalValue?.stages?.length || cancelled === 1
                  ? "100%"
                  : "60%",
              lg:
                !originalValue?.stages?.length || cancelled === 1
                  ? "100%"
                  : "70%",
              xl:
                !originalValue?.stages?.length || cancelled === 1
                  ? "100%"
                  : "70%",
            },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            flexWrap="wrap"
            sx={{
              background: "#006CB8",
              border: "0px solid white",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            {/* Tabs aligned to left */}
            <Tabs
              value={selectedProfileTab}
              onChange={(e, value) => {
                setSelectedProfileTab(value);
              }}
              indicatorColor="error"
              textColor="error"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                fontFamily: "Geist, sans-serif",
                "& .MuiTabs-flexContainer": { justifyContent: "flex-start" },
                borderRadius: "10px 0px 0px 0px",
              }}
            >
              {["Personal Details", "Experience Details", "Applied Jobs"].map(
                (label, index) => (
                  <Tab
                    key={label}
                    label={label}
                    sx={{
                      fontFamily: "Geist, sans-serif",
                      background:
                        selectedProfileTab !== index ? "#006CB8" : "white",
                      border: "1px solid lightgrey",
                      borderLeft:
                        index == 0
                          ? selectedProfileTab == index
                            ? "1px solid lightgrey"
                            : "0px"
                          : "0px",
                      borderBottom: "4px solid #EAB308",
                      color: selectedProfileTab !== index ? "white" : "black",
                      fontWeight: 500,
                      fontSize: `14px`,
                      letterSpacing: "1px",
                      minWidth: "150px",
                      minHeight: "60px",
                      borderRadius: index == 0 ? "10px 0px 0px 0px" : "",
                    }}
                  />
                )
              )}
            </Tabs>
          </Box>
          <Grid
            container
            spacing={2}
            ref={redGridRef}
            // sx={{border: "2px solid red"}}
          >
            {/* Personal Details Card */}
            {selectedProfileTab == 0 && (
              <>
                <Grid item xs={12} id="personalDetailsSection">
                  <Box
                    sx={{
                      border: "1px solid lightgrey",
                      p: 3,
                    }}
                  >
                    <Grid container spacing={2}>
                      {personalDetails?.CI_Photo && (
                        <Grid
                          container
                          spacing={2}
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={3}
                          xl={2.5}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            minHeight: "100%", // or a fixed height like '300px' if needed
                          }}
                        >
                          {personalDetails?.CI_Photo && (
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              flexDirection="column"
                            >
                              <Avatar
                                src={`${process.env.REACT_APP_BASE_URL}/${personalDetails?.CI_Photo}`}
                                alt="Candidate"
                                sx={{
                                  width: 200,
                                  height: 200,
                                  mb: 1,
                                  border: "1px solid lightgrey",
                                }}
                              />
                            </Box>
                          )}
                        </Grid>
                      )}

                      <Grid
                        container
                        spacing={2}
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={personalDetails?.CI_Photo ? 9 : 12}
                        xl={personalDetails?.CI_Photo ? 9.5 : 12}
                      >
                        {Object.entries(personalDetails)
                          .filter(([key]) => key !== "CI_Photo")
                          .map(([key, value]) => (
                            <Grid
                              item
                              xs={key === "Address" ? 12 : 12}
                              sm={
                                key === "Address"
                                  ? 12
                                  : originalValue?.stages?.length
                                  ? 12
                                  : 6
                              }
                              md={
                                key === "Address"
                                  ? 12
                                  : originalValue?.stages?.length
                                  ? 6
                                  : 4
                              }
                              lg={
                                key === "Address"
                                  ? 12
                                  : originalValue?.stages?.length
                                  ? 6
                                  : 4
                              }
                              xl={
                                key === "Address"
                                  ? 12
                                  : originalValue?.stages?.length
                                  ? 4
                                  : 3
                              }
                              my={1}
                              key={key}
                            >
                              <Box>
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    mb: 0.5,
                                  }}
                                >
                                  {key.replace(/_/g, " ")}
                                </Typography>
                                {value ? (
                                  <Typography
                                    sx={{ fontWeight: 400, fontSize: "16px" }}
                                  >
                                    {value}
                                  </Typography>
                                ) : (
                                  <Skeleton
                                    variant="text"
                                    width="80%"
                                    height={40}
                                  />
                                )}
                              </Box>
                            </Grid>
                          ))}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </>
            )}

            {/* Job Details Card */}
            {selectedProfileTab == 1 && (
              <Grid item xs={12} id="jobDetailsSection">
                <Box
                  sx={{
                    border: "1px solid lightgrey",
                    p: 3,
                  }}
                >
                  <Grid container spacing={2}>
                    {Object.entries(jobDetails).map(([key, value]) => (
                      <Grid
                        item
                        xs={12}
                        sm={originalValue?.stages?.length ? 12 : 6}
                        md={originalValue?.stages?.length ? 6 : 4}
                        lg={originalValue?.stages?.length ? 6 : 4}
                        xl={originalValue?.stages?.length ? 4 : 3}
                        key={key}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "18px",
                              mb: 0.5,
                            }}
                          >
                            {key.replace(/_/g, " ")}
                          </Typography>
                          {value ? (
                            <Typography
                              sx={{
                                fontWeight: 400,
                                fontFamily: "Geist, sans-serif",
                                fontSize: "16px",
                              }}
                            >
                              {value}
                            </Typography>
                          ) : (
                            <Skeleton variant="text" width="80%" height={40} />
                          )}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Grid>
            )}

            {/* Applied Jobs */}
            {selectedProfileTab == 2 && (
              <Grid item xs={12} id="jobDetailsSection">
                <Box sx={{ border: "1px solid lightgrey", borderRadius: 0 }}>
                  <Accordion
                    expanded={expanded}
                    elevation={0}
                    sx={{
                      background: "white",
                      px: 2,
                      borderRadius: 0,
                    }}
                  >
                    <AccordionSummary
                      aria-controls="applied-jobs-content"
                      id="applied-jobs-header"
                      sx={{ p: 0, background: "white" }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        width="100%"
                      >
                        <Typography
                          sx={{
                            fontFamily: "Geist, sans-serif",
                            fontWeight: `700`,
                            fontStyle: `Bold`,
                            fontSize: `20px`,
                            leadingTrim: `NONE`,
                            lineHeight: `100%`,
                            letterSpacing: `0%`,
                            fontSize: "24px",
                          }}
                        >
                          Applied Jobs
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Button
                            variant="contained"
                            startIcon={<Add />}
                            onClick={navigatetoJobLinkingAdd}
                          >
                            Add
                          </Button>
                          <IconButton
                            onClick={handleAccordionToggle}
                            sx={{
                              border: "2px solid lightgrey",
                              // transform: expanded ? "rotate(180deg)": "rotate(0deg)",
                              transform: expanded ? "scaleY(-1)" : "scaleY(1)",
                              transition: "transform 0.5s ease",
                            }}
                          >
                            <ExpandMore />
                          </IconButton>
                        </Box>
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails
                      sx={{ p: 0, background: "white", overflowX: "auto" }}
                    >
                      <Grid container sx={{ minWidth: "950px", mb: 2 }}>
                        {/* Header Row */}
                        <Grid
                          container
                          sx={{
                            backgroundColor: "#006CB8",
                            color: "white",
                            p: 1.5,
                            borderRadius: "10px 10px 0px 0px",
                          }}
                        >
                          {/* Job Title + Radio */}
                          <Grid item xs={3}>
                            <Typography variant="subtitle2" fontWeight="600">
                              Job Title
                            </Typography>
                          </Grid>

                          {/* CV Sent */}
                          <Grid item xs={1}>
                            <Typography variant="subtitle2" fontWeight="600">
                              CV Sent
                            </Typography>
                          </Grid>

                          {/* Shortlisted */}
                          <Grid item xs={1.2}>
                            <Typography variant="subtitle2" fontWeight="600">
                              Shortlisted
                            </Typography>
                          </Grid>

                          {/* Offer Status */}
                          <Grid item xs={1.8}>
                            <Typography variant="subtitle2" fontWeight="600">
                              Offer Letter Status
                            </Typography>
                          </Grid>

                          {/* Interview Status Dropdown */}
                          <Grid item xs={3.5}>
                            <Typography variant="subtitle2" fontWeight="600">
                              Interview Status
                            </Typography>
                          </Grid>

                          {/* Action Button */}
                          <Grid
                            item
                            xs={1}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography variant="subtitle2" fontWeight="600">
                              Action
                            </Typography>
                          </Grid>
                        </Grid>

                        {/* Data Rows */}
                        {appliedJobs?.length > 0 ? (
                          appliedJobs.map((job) => {
                            const isSelected =
                              selectedJobListId == job?.JD_JobId;

                            return (
                              <Grid
                                container
                                key={job.JD_JobId}
                                alignItems="center"
                                sx={{
                                  border: isSelected
                                    ? "3px solid #006CB8"
                                    : "1px solid lightgrey",
                                  background: job?.JA_Isdeployed
                                    ? "#009132"
                                    : job?.JD_Cancelled
                                    ? "#E7625F"
                                    : isSelected
                                    ? "#006CB80A"
                                    : "white",
                                  px: 1,
                                  py: 0.5,
                                  color:
                                    job?.JD_Cancelled || job?.JA_Isdeployed
                                      ? "white"
                                      : "black",
                                }}
                              >
                                {/* Job Title + Radio */}
                                <Grid item xs={3}>
                                  <FormControl
                                    component="fieldset"
                                    sx={{ width: "100%" }}
                                  >
                                    <RadioGroup
                                      value={selectedJobListId}
                                      onChange={(e) => {
                                        handleChange(e?.target?.value);
                                      }}
                                    >
                                      <FormControlLabel
                                        value={job.JD_JobId}
                                        control={
                                          <Radio
                                            sx={{
                                              transform: "scale(1.3)",
                                              m: 1,
                                              color:
                                                job?.JA_Isdeployed ||
                                                job?.JD_Cancelled
                                                  ? "white"
                                                  : "rgba(0, 0, 0, 0.6)",
                                              "&.Mui-checked": {
                                                color:
                                                  job?.JA_Isdeployed ||
                                                  job?.JD_Cancelled
                                                    ? "white"
                                                    : "#006CB8", // or your default primary color
                                              },
                                            }}
                                          />
                                        }
                                        label={
                                          <Typography variant="body2">
                                            {job.JD_Title}
                                          </Typography>
                                        }
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Grid>

                                {/* CV Sent */}
                                <Grid item xs={1}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {job?.JD_CvSent == 1 ? "Yes" : "No"}
                                  </Typography>
                                </Grid>

                                {/* Shortlisted */}
                                <Grid item xs={1.2}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {job?.JD_Shortlisted == 1 ? "Yes" : "No"}
                                  </Typography>
                                </Grid>

                                {/* Offer Status */}
                                <Grid item xs={1.8}>
                                  <Typography variant="body2" fontWeight={500}>
                                    {job?.JD_OfferStatusName
                                      ? job?.JD_OfferStatusName
                                      : "-"}
                                  </Typography>
                                </Grid>

                                {/* Interview Status Dropdown */}
                                <Grid item xs={3.5}>
                                  <FormControl
                                    fullWidth
                                    size="small"
                                    sx={{ backgroundColor: "white" }}
                                  >
                                    <SelectInput
                                      value={job?.JASL_Id}
                                      name="jobapplication"
                                      onChange={(e) =>
                                        handleStatusChange(job, e)
                                      }
                                      options={statusList?.map((item) => ({
                                        value: item?.JASL_Id,
                                        label: item?.JASL_Name,
                                      }))}
                                      isDisabled={
                                        !isSelected ||
                                        job?.JA_Isdeployed ||
                                        job?.JD_Cancelled
                                      }
                                      placeholder="Select Status"
                                      customStyle={{
                                        background: job?.JA_Isdeployed
                                          ? "#009132"
                                          : job?.JD_Cancelled
                                          ? "#E7625F"
                                          : "",
                                        borderRadius: 4,
                                        border: "1px solid lightgrey",
                                        isWhiteText:
                                          job?.JA_Isdeployed ||
                                          job?.JD_Cancelled,
                                      }}
                                    />
                                  </FormControl>
                                </Grid>

                                {/* Action Button */}
                                <Grid
                                  item
                                  xs={1}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    onClick={() =>
                                      navigatetoJobLinkingEdit(job)
                                    }
                                    disabled={
                                      !isSelected ||
                                      job?.JA_Isdeployed ||
                                      job?.JD_Cancelled
                                    }
                                    sx={{
                                      color: "#006CB8",
                                      backgroundColor: "white",
                                      border: `2px solid ${
                                        job?.JA_Isdeployed || job?.JD_Cancelled
                                          ? "transparent"
                                          : isSelected
                                          ? "#006CB8"
                                          : "grey"
                                      }`,
                                      opacity: isSelected ? 1 : 0.5,
                                      "&:hover": { backgroundColor: "#e0f0ff" },
                                    }}
                                    size="small"
                                  >
                                    <Edit />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            );
                          })
                        ) : (
                          <Box
                            height={150}
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              color: "grey",
                              fontSize: "28px",
                              width: "100%",
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "Geist, sans-serif",
                                letterSpacing: `0.5px`,
                                fontSize: "24px",
                                color: "grey",
                                fontWeight: "600",
                              }}
                            >
                              No data to show
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </Grid>
            )}

            {/* Recruitment Procedure Details */}
            {recruitmentProfession && recruitmentCountry && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: "1px solid lightgrey",
                    borderRadius: 1,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "#006CB81F",
                      p: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      Recruitment Procedure Details
                    </Typography>
                  </Box>

                  <Grid container spacing={2} p={2}>
                    {/* Left Side: Country, Profession, Job */}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={cancelled == 1 ? 6 : 12}
                      lg={6}
                      xl={8}
                    >
                      <Box
                        sx={{
                          border: "2px solid #006CB8",
                          height: "100%",
                          padding: 2,
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "18px",
                              mb: 0.5,
                              minWidth: "250px",
                            }}
                          >
                            Destination Country
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",

                              minWidth: "250px",
                            }}
                          >
                            {recruitmentCountry || "-"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "18px",
                              mb: 0.5,
                              minWidth: "250px",
                            }}
                          >
                            Recruitment Profession
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",

                              minWidth: "250px",
                            }}
                          >
                            {recruitmentProfession || "-"}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "18px",
                              mb: 0.5,
                              minWidth: "250px",
                            }}
                          >
                            Recruitment Job
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",

                              minWidth: "250px",
                            }}
                          >
                            {selectedJobName
                              ? `${selectedJobName} ${
                                  selectedJobID ? `(${selectedJobID})` : ""
                                }`
                              : "-"}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    {/* Right Side: Deployed & Cancelled Checkboxes */}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={cancelled == 1 ? 6 : 12}
                      lg={6}
                      xl={4}
                    >
                      <Box
                        sx={{
                          border: "2px solid #006CB8",
                          height: "100%",
                          padding: 2,
                          borderRadius: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        {/* Deployed Box */}
                        <Box
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: 1,
                            padding: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: 500,
                            }}
                          >
                            Deployed
                          </Typography>
                          <IconButton
                            onClick={() =>
                              handleCheckboxClick("Deployed", deployed !== 1)
                            }
                            disabled={cancelled === 1}
                            color="primary"
                          >
                            {deployed === 1 ? (
                              <CheckCircle color="primary" fontSize="large" />
                            ) : (
                              <RadioButtonUnchecked
                                sx={{
                                  color: cancelled === 1 ? "#ccc" : "grey",
                                }}
                                fontSize="large"
                              />
                            )}
                          </IconButton>
                        </Box>

                        {/* Cancelled Box */}
                        <Box
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: 1,
                            padding: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: 500,
                            }}
                          >
                            Cancelled
                          </Typography>
                          <IconButton
                            onClick={() =>
                              handleCheckboxClick("Cancelled", cancelled !== 1)
                            }
                            disabled={deployed === 1}
                            color="primary"
                          >
                            {cancelled === 1 ? (
                              <CheckCircle fontSize="large" color="primary" />
                            ) : (
                              <RadioButtonUnchecked
                                fontSize="large"
                                sx={{ color: deployed === 1 ? "#ccc" : "grey" }}
                              />
                            )}
                          </IconButton>
                        </Box>

                        {/* Cancelled Remarks */}
                        {cancelled === 1 && cancelRemarkPreview && (
                          <Typography
                            sx={{
                              fontFamily: "Geist, sans-serif",
                              fontSize: "16px",
                              color: "#333",
                              fontWeight: 500,
                            }}
                          >
                            Remarks : {cancelRemarkPreview}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>

        {cancelled != 1 && originalValue?.stages?.length > 0 && (
          <Box
            sx={{
              // border: "2px solid blue",
              overflowY: "auto",
              maxHeight: `${redGridHeight + 46}px`,
              width: {
                xs: "100%", // full width below red box on small screens
                sm: "100%", // side-by-side on desktop
                md: "40%",
                lg: "30%",
                xl: "30%",
              },
            }}
            id="statusDetailsSection"
          >
            <Card
              sx={{
                height: "100%",
                overflowY: "auto",
                border: "1px solid lightgrey",
                boxShadow: "none",
                borderRadius: `10px`,
              }}
            >
              <Box>
                <Typography
                  fontWeight={600}
                  mb={2}
                  p={2.1}
                  sx={{
                    minHeight: "61px",
                    background: "#006CB8",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  Status of {selectedJobName}
                </Typography>

                {originalValue2?.stages?.map((stage, index) => {
                  const hasSubProcedures =
                    Array.isArray(stage.subProcedures) &&
                    stage.subProcedures.length > 0;

                  let stageStatus = "0"; // default: in progress

                  const subComponents = hasSubProcedures
                    ? stage.subProcedures.map((sub) => {
                        const fields = sub?.fields || [];
                        const statusField = fields.find(
                          (field) => field?.RPF_Type === "IsCompleted"
                        );
                        const status =
                          [statusField?.RPF_Value].flat()[0] || "0";
                        return {
                          ...sub,
                          isCompleted: status,
                        };
                      })
                    : [];

                  if (hasSubProcedures) {
                    const statuses = subComponents.map((s) => s.isCompleted);
                    if (statuses.every((s) => s === "1")) {
                      stageStatus = "1";
                    } else if (statuses.every((s) => s === "2")) {
                      stageStatus = "2";
                    } else {
                      stageStatus = "0";
                    }
                  } else {
                    const stageField = stage?.fields?.find(
                      (field) => field?.RPF_Type === "IsCompleted"
                    );

                    stageStatus = [stageField?.RPF_Value].flat()[0] || "0";
                  }
                  // Color code for sidebar
                  const getStageColor = (status) => {
                    switch (status) {
                      case "1":
                        return {
                          border: "#22C55E", //Green
                          bg: "#22C55E0D",
                          label: "Completed",
                        };
                      case "2":
                        return {
                          border: "#9CA3AF", // Greyish (Tailwind's gray-400)
                          bg: "#9CA3AF0D",
                          label: "Draft",
                        };
                      default:
                        return {
                          border: "#006CB8", // Blue
                          bg: "#EBF2FF",
                          label: "In Progress",
                        };
                    }
                  };
                  // 0 = in progress
                  // 1 = completed
                  // 2 = Draft

                  const subStatus = stageStatus;
                  const stageColor = getStageColor(stageStatus);

                  // _______________________________________________________________________________________________________________________

                  // Split fields into two categories
                  const fieldsOnly = stage?.fields || [];

                  const subProcedureFields = (
                    stage?.subProcedures || []
                  ).flatMap((sub) => sub?.fields || []);

                  const stageStatusField = fieldsOnly.find((field) =>
                    field?.RPF_Name?.trim()?.toLowerCase().includes("status")
                  );

                  const stageStatusSubField = subProcedureFields.find((field) =>
                    field?.RPF_Name?.trim()?.toLowerCase().includes("status")
                  );

                  const stageStatusFieldPosition = (stage?.fields || []).find(
                    (field) => field?.RPF_Id == stageStatusField?.RPF_Id
                  );

                  function getExpiryStatus(field) {
                    if (field.RPF_Type !== "Date") return null;

                    // 🔹 Check if expiry is enabled
                    if (field.RPF_IsExpiry == undefined) {
                      return null;
                    }

                    // 1. Parse expiry period
                    let expiryDays = 0;
                    if (
                      field.RPF_ExpiryPeriod &&
                      field.RPF_IsExpiry != undefined
                    ) {
                      try {
                        expiryDays = Number(
                          field.RPF_ExpiryPeriod.toString().replace(/"/g, "")
                        );
                      } catch {
                        expiryDays = 0;
                      }
                    }

                    // 2. Parse the base date (RPF_Value)
                    if (!field.RPF_Value) return null;
                    const baseDate = new Date(field.RPF_Value);
                    if (isNaN(baseDate)) return null;

                    // 3. Calculate expiry date
                    const expiryDate = new Date(baseDate);
                    expiryDate.setDate(baseDate.getDate() + expiryDays);

                    // 4. Compare with today
                    const today = new Date();
                    const diffTime = expiryDate - today;
                    const diffDays = Math.ceil(
                      diffTime / (1000 * 60 * 60 * 24)
                    );

                    // Helper for singular/plural
                    const dayLabel = (n) =>
                      Math.abs(n) === 1 ? "day" : "days";

                    // 5. Handle result
                    if (diffDays > 30) {
                      return null; // don’t show if more than 30 days left
                    } else if (diffDays > 0) {
                      return {
                        value: `${field.RPF_Name}: ${diffDays} ${dayLabel(
                          diffDays
                        )} pending`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays === 0) {
                      return {
                        value: `${field.RPF_Name}: Expires today`,
                        fontSize: "16px",
                        color: "black",
                      };
                    } else if (diffDays >= -60) {
                      return {
                        value: `${field.RPF_Name}: Expired ${Math.abs(
                          diffDays
                        )} ${dayLabel(diffDays)} ago`,
                        fontSize: "16px",
                        color: "red",
                      };
                    } else {
                      return null; // don’t show if expired more than 60 days ago
                    }
                  }

                  return (
                    <Box
                      key={index}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: 2,
                        backgroundColor: stageColor.bg,
                        borderLeft: `5px solid ${stageColor.border}`,
                        boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                        margin: "15px",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        {getIcon(
                          subStatus == "1"
                            ? "Completed"
                            : subStatus == "2"
                            ? "Draft"
                            : "In Progress",
                          stageColor.border
                        )}
                        <Box>
                          <Typography fontWeight="bold">
                            {stage.RPS_Name}
                          </Typography>

                          {stageStatusFieldPosition && (
                            <Typography
                              sx={{ color: stageColor.border }}
                              fontSize="14"
                            >
                              {stageStatusFieldPosition.RPF_Value
                                ? `${stageStatusFieldPosition?.RPF_Name} : `
                                : ""}
                              {Array.isArray(stageStatusFieldPosition.RPF_Value)
                                ? stageStatusFieldPosition.RPF_Value.join(", ")
                                : stageStatusFieldPosition.RPF_Value || ""}
                            </Typography>
                          )}

                          {/* New Implementation - 09-09-25 - Expiry Date */}

                          {stage?.fields?.map((field) => {
                            const status = getExpiryStatus(field);

                            return (
                              <Box key={field.RPF_Id}>
                                {status?.value && (
                                  <Typography
                                    sx={{
                                      fontSize: status?.fontSize,
                                      color: status?.color,
                                      textTransform: "Capitalize",
                                    }}
                                  >
                                    {status?.value}
                                  </Typography>
                                )}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>

                      {hasSubProcedures &&
                        subComponents.map((sub, subIndex) => {
                          const subStatus = sub.isCompleted;

                          const subColor = getStageColor(subStatus);

                          const stageStatusSubFieldPosition = (
                            sub?.fields || []
                          ).find(
                            (field) =>
                              field?.RPF_Id == stageStatusSubField?.RPF_Id
                          );

                          return (
                            <Box
                              key={`sub-${subIndex}`}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                mt: 1.5,
                                p: 1.5,
                                borderRadius: 2,
                                backgroundColor: subColor.bg,
                                borderLeft: `4px solid ${subColor.border}`,
                              }}
                            >
                              {getIcon(
                                subStatus == "1"
                                  ? "Completed"
                                  : subStatus == "2"
                                  ? "Draft"
                                  : "In Progress",
                                subColor.border
                              )}
                              <Box>
                                <Typography fontWeight={500}>
                                  {sub.RSP_Name}
                                </Typography>

                                {stageStatusSubFieldPosition && (
                                  <Typography
                                    sx={{ color: subColor.border }}
                                    fontSize="14"
                                  >
                                    {stageStatusSubFieldPosition.RPF_Value
                                      ? `${stageStatusSubFieldPosition?.RPF_Name} : `
                                      : ""}
                                    {Array.isArray(
                                      stageStatusSubFieldPosition.RPF_Value
                                    )
                                      ? stageStatusSubFieldPosition.RPF_Value.join(
                                          ", "
                                        )
                                      : stageStatusSubFieldPosition.RPF_Value ||
                                        ""}
                                  </Typography>
                                )}

                                {/* New Implementation - 09-09-25 - Expiry Date */}

                                {sub?.fields?.map((field) => {
                                  const status = getExpiryStatus(field);
                                  return (
                                    <Box key={field.RPF_Id}>
                                      {status && (
                                        <Typography
                                          sx={{
                                            fontSize: status?.fontSize,
                                            color: status?.color,
                                            textTransform: "Capitalize",
                                          }}
                                        >
                                          {status?.value}
                                        </Typography>
                                      )}
                                    </Box>
                                  );
                                })}
                              </Box>
                            </Box>
                          );
                        })}
                    </Box>
                  );
                })}
              </Box>
            </Card>
          </Box>
        )}
      </Box>

      {decryptedJAId && cancelled != 1 && (
        <ProcessFlowViewer
          personalDetails={personalDetails}
          jobDetails={jobDetails}
          candidateIDOriginal={id}
          candidateID={decryptedId}
          JAID={decryptedJAId}
          countryID={countryID}
          professionID={professionID}
          rpmID={rpmID}
          originalValue={originalValue}
          currentProcessFlowDataParent={currentProcessFlowData}
          loading={loading}
          error={errorParent}
          mainAPICallback={mainAPICallback}
          setMainAPICallback={setMainAPICallback}
          mainValue={mainValue}
          setMainValue={setMainValue}
          callInterview={callInterview}
        />
      )}

      {/* Confirmation Dialog */}
      <Dialog open={confirmOpen} onClose={handleCancel}>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#0977BC",
            mt: 3,
            mb: 2,
            fontFamily: "Geist, sans-serif",
          }}
        >
          Confirm Action
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1,
                fontFamily: "Geist, sans-serif",
              }}
            >
              Are you sure you want to{" "}
              {pendingChange?.value ? "enable" : "disable"}{" "}
              {pendingChange?.type} Status?
            </Typography>

            {pendingChange?.type === "Cancelled" && cancelled != 1 && (
              <TextAreaInput
                label="Cancel Remark"
                placeholder="Cancel Remark"
                value={cancelRemark}
                onChange={(e) => setCancelRemark(e.target.value)}
              />
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ mt: 3, mb: 3, mr: 3 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <CommonButton
              variant="outlined"
              customColor="#B0BEC5"
              onClick={handleCancel}
            >
              Cancel
            </CommonButton>
            <CommonButton
              variant="contained"
              customColor="#007BFF"
              onClick={handleCheckboxConfirm}
              disabled={
                pendingChange?.type === "Cancelled" && cancelled !== 1
                  ? cancelRemark?.trim().length < 1
                  : false
              }
            >
              Proceed
            </CommonButton>
          </Box>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openExport}
        onClose={() => setOpenExport(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Enter ZIP Password
          <IconButton onClick={() => setOpenExport(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container>
            <Grid item sx={{ padding: "5px" }} xs={12}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Zip Name
              </Typography>
              <TextInput
                fullWidth
                label="ZIP File Name"
                value={zipFileName}
                onChange={(e) => setZipFileName(e.target.value)}
                placeholder="e.g., MyData.zip"
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item sx={{ padding: "5px" }} xs={12}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
              >
                Password
              </Typography>
              <TextInput
                fullWidth
                label="Password"
                type="password"
                value={zipPassword}
                onChange={(e) => {
                  setZipPassword(e.target.value);
                  setError("");
                }}
                error={!!error}
                helperText={error}
                autoFocus
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenExport(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleExport} variant="contained" color="primary">
            Confirm & Export
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default CandidateProfile;
